import { Component, Input } from '@angular/core';
import { DayOfWeekEnum, OperationHour, SpecialHour, SpecialHourTime } from 'app/models';
import moment from 'moment';

enum HoursMenuTab {
    OperationHours = 1,
    SpecialHours = 2
}

@Component({
    selector: 'partner-mart-locations-hours',
    templateUrl: './partner-mart-locations-hours.component.html',
    styleUrls: ['./partner-mart-locations-hours.component.scss']
})
export class PartnerMartLocationsHoursComponent {
    @Input()
    public operationHours: OperationHour[] = [new OperationHour()];

    @Input()
    public specialHours: SpecialHour[] = [new SpecialHour()];

    public hoursMenuTab = HoursMenuTab;
    public activeHoursMenuTab: HoursMenuTab = HoursMenuTab.OperationHours;

    public daysWeek: any[] = [
        { name: 'Mon', value: DayOfWeekEnum.Monday },
        { name: 'Tue', value: DayOfWeekEnum.Tuesday },
        { name: 'Wed', value: DayOfWeekEnum.Wednesday },
        { name: 'Thu', value: DayOfWeekEnum.Thursday },
        { name: 'Fri', value: DayOfWeekEnum.Friday },
        { name: 'Sat', value: DayOfWeekEnum.Saturday },
        { name: 'Sun', value: DayOfWeekEnum.Sunday }
    ];

    public changeHoursMenuTab(hoursMenuTab: HoursMenuTab) {
        this.activeHoursMenuTab = hoursMenuTab;
    }

    public addOperationHour() {
        this.operationHours.push({
            SelectedDaysWeek: [],
            SelectStartTime: null,
            SelectStartTimeIsEmpty: false,
            SelectEndTime: null,
            SelectEndTimeIsEmpty: false,
        });
    }
    public deleteOperationHour(index: number) {
        this.operationHours.splice(index, 1);
    }

    public addSpecialHour() {
        this.specialHours.push(new SpecialHour());
    }
    public deleteSpecialHour(index: number) {
        this.specialHours.splice(index, 1);
    }

    public addSpecialTime(objSpecialHour: any) {
        objSpecialHour.StoreSpecialHourTimes.push(new SpecialHourTime());
    }
    public deleteSpecialTime(objSpecialHour: any, index: number) {
        objSpecialHour.StoreSpecialHourTimes.splice(index, 1);
    }

    public getOperationHours(): OperationHour[] {
        return this.operationHours;
    }

    public getSpecialHours(): SpecialHour[] {
        return this.specialHours;
    }

    public getOperationHoursDto(): any[] {
        const operationHoursDto: any[] = [];

        this.operationHours.forEach((obj: OperationHour) => {
            if (obj.SelectedDaysWeek.length && obj.SelectStartTime && obj.SelectEndTime) {
                obj.SelectedDaysWeek.forEach((item: any) => {
                    operationHoursDto.push({
                        DayOfWeek: item,
                        StartTime: moment(obj.SelectStartTime).format('YYYY-MM-DDTHH:mm:ss'),
                        EndTime: moment(obj.SelectEndTime).format('YYYY-MM-DDTHH:mm:ss')
                    });
                });
            }
        });

        return operationHoursDto;
    }

    public getSpecialHoursDto(): any[] {
        const specialHoursDto: any[] = [];

        this.specialHours.forEach((obj: SpecialHour) => {
            if (obj.Title && obj.StartDate && obj.EndDate) {
                let ok = true;

                const hourDto: any = Object.assign({}, obj);

                hourDto.StartDate = moment(obj.StartDate).format('YYYY-MM-DDTHH:mm:ss');
                hourDto.EndDate = moment(obj.EndDate).format('YYYY-MM-DDTHH:mm:ss');

                for (const item of hourDto.StoreSpecialHourTimes) {
                    if (!item.OpensAt || !item.ClosesAt) {
                        ok = false;
                        break;
                    }

                    item.OpensAt = moment(item.OpensAt).format('YYYY-MM-DDTHH:mm:ss');
                    item.ClosesAt = moment(item.ClosesAt).format('YYYY-MM-DDTHH:mm:ss');
                }

                if (ok) {
                    specialHoursDto.push(hourDto);
                }
            }
        });

        return specialHoursDto;
    }
}
